export const LoadingIndicator = () => {
    return <div id="global-loader">
        <img src="../assets/img/loader.svg" className="loader-img" alt="Loader" />
    </div>;
}